import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { get } from 'utils/http'

export const useCustomerDomains = () => {
  const customerId = useCustomerId()

  return useQuery({
    queryKey: ['customer', customerId, 'domains'],
    queryFn: () => get(`/management/customers/${customerId}/domains?`),
  })
}
